import React, { useCallback, useRef, useState } from 'react';
import Alert from 'utils/packages/Alert';
import emoji from 'node-emoji';
import Animated from 'react-native-reanimated';
import { AppView, CardView, SettingsItemInput, SCROLL_INDICATOR_INSETS, StatusBar, } from 'design-system';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import { IconText } from 'design-system/icons';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { focus, useAutoFocusInput } from 'hooks/useAutoFocusInput';
import useColors from 'hooks/useColors';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { KeyboardAvoidingButton } from 'design-system/KeyboardAvoidingButton';
import GroupNameSuggestions from './components/GroupNameSuggestions';
const GroupCreateScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const [name, setName] = useState('');
    const colors = useColors();
    const nameRef = useRef(null);
    useAutoFocusInput(nameRef);
    const onContinue = useCallback(async () => {
        if (!name.trim().length) {
            Alert.alert(emoji.emojify('Hold on :dizzy:'), 'You must enter a name.', [{ onPress: () => focus(nameRef) }]);
            return;
        }
        navigation.navigateDeprecated('GroupInvite', { name });
    }, [name]);
    const [suggestedData, setSuggestedData] = useState();
    const handleSuggestionPress = useCallback((name) => {
        setName(name);
        setSuggestedData({ name });
    }, []);
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle);
    return (<AppView withFrame={false}>
        <StatusBar barStyle="dark-content" animated/>
        <Animated.ScrollView scrollEventThrottle={16} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} onScroll={scrollHandler} contentContainerStyle={paddingBottom} keyboardShouldPersistTaps="handled">
          <CardView noMarginBottom>
            <SettingsItemInput ref={nameRef} description="Name" icon={<IconText gradientColors={colors.gradients.darkPink.colors}/>} value={name} onChangeText={setName} placeholder="Choose.." iconSize={44} onSubmitEditing={onContinue} returnKeyType="done"/>
          </CardView>
          <GroupNameSuggestions name={name} handleSuggestionPress={handleSuggestionPress} suggestedData={suggestedData}/>
        </Animated.ScrollView>
        <KeyboardAvoidingButton brand disabled={!name} onPress={onContinue} title="Continue"/>
      </AppView>);
}, ({ colors }) => ({
    title: 'Group name',
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default GroupCreateScreen;
